import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Index from "./page/index";
import Login from "./page/login";
import Register from "./page/register";
import PolicyPrivacy from "./page/policy_privacy.js";


// SUPER USER / ADMIN
import Cart from "./page/customer/cart.js";
import Product from "./page/customer/product.js";
import Main from "./page/customer/main.js";
import ProductDetail from "./page/customer/product-detail.js";
import Transaction from "./page/customer/transaction.js";
import Profile from "./page/customer/profile.js";
import Address from "./page/customer/address.js";
import ChangePassword from "./page/customer/change-password.js";
import Help from "./page/customer/help.js";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    {/* <Route path="/" element={<Loading />} /> */}

    <Route path="/" element={<Index />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />


    {/* Admin */}
    <Route path="/cart" element={<Cart />} />
    <Route path="/main" element={<Main />} />
    <Route path="/product" element={<Product />} />
    <Route path="/product-detail" element={<ProductDetail />} />
    <Route path="/transaction" element={<Transaction />} />
    <Route path="/profile" element={<Profile />} />
    <Route path="/address" element={<Address />} />
    <Route path="/change-password" element={<ChangePassword />} />
    <Route path="/help" element={<Help />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
